import React, { useState, useEffect } from "react";
import { XIcon } from "staysure-component-library";

import { IconButtonWrapper } from "@/components/atoms/button-wrapper/button-wrapper";
import withBrand from "@/components/with-brand";
import selectedColorBrand from "@/config/tailwind-colors/brand-colors";
import { ToggleModalContentType } from "@/schema/quote-page/page.schema";

import StAmtTogleModalCancellation from "./st-amt-canceltion/st-amt-canceltion";
import StAmtTogleModalNewDate from "./st-amt-new-date/st-amt-new-date";

type StAmtTogleModalProps = {
  brand?: "avanti" | "staysure";
  isOpenViaBottomToggle?: boolean;
  onCancel: () => void;
  onCancelModal?: () => void;
  onUpdated?: () => void;
  onIsNewDateUpdate?: (isNewDateUpdate: boolean) => void;
  modalRef?: React.RefObject<HTMLDivElement | null>;
};

function StAmtTogleModal({
  onCancel,
  onCancelModal,
  onUpdated,
  stAmtToggleCancellaionTitle,
  stAmtToggleCancellaionDescription,
  stAmtToggleCancellaionDescriptionMoreThanNinetyDays,
  stAmtToggleCancellaionContinueBtnLabele,
  stAmtToggleCancellaionNewDateBtnLabel,
  stAmtToggleNewDateDatePickerPlaceHolder,
  stAmtToggleNewDateTitle,
  stAmtToggleNewDateUpdateBtnLabel,
  stAmtToggleNewDateCancelButtonLabel,
  isOpenViaBottomToggle,
  onIsNewDateUpdate,
  modalRef,
}: Readonly<StAmtTogleModalProps & Partial<ToggleModalContentType>>) {
  const [isNewDateUpdate, setIsNewDateUpdate] = useState(false);
  useEffect(() => {
    if (onIsNewDateUpdate) {
      onIsNewDateUpdate(isNewDateUpdate);
    }
  }, [isNewDateUpdate, onIsNewDateUpdate]);
  return (
    <div className="md:p-spacing-xxxl p-spacing-l" ref={modalRef}>
      <div className="md:w-spacing-xxxl md:h-spacing-xxxl w-spacing-xxl h-spacing-xxl absolute m-[2px] right-0 top-0 flex items-center justify-center">
        <IconButtonWrapper
          data-testid="remove-modal-close-button"
          id="remove-modal-close-button"
          hierarchy="tertiary"
          btnType="icon"
          icon={
            <XIcon
              stroke={selectedColorBrand["interactive-secondary-default"]}
            />
          }
          className="w-[24px] h-[24px] text-[24px] text-text-on-primary "
          onClick={() => {
            (onCancelModal ?? onCancel)?.();
          }}
        />
      </div>

      <div>
        {isNewDateUpdate ? (
          <StAmtTogleModalNewDate
            onCancel={() => {
              onCancel();
            }}
            onCancelModal={onCancelModal}
            onUpdated={onUpdated}
            stAmtToggleNewDateUpdateBtnLabel={stAmtToggleNewDateUpdateBtnLabel}
            stAmtToggleNewDateCancelButtonLabel={
              stAmtToggleNewDateCancelButtonLabel
            }
            stAmtToggleNewDateDatePickerPlaceHolder={
              stAmtToggleNewDateDatePickerPlaceHolder
            }
            stAmtToggleNewDateTitle={stAmtToggleNewDateTitle}
            isOpenViaBottomToggle={isOpenViaBottomToggle}
          />
        ) : (
          <StAmtTogleModalCancellation
            onCancel={() => {
              onCancel();
            }}
            onNewDate={() => {
              setIsNewDateUpdate(true);
            }}
            onUpdated={onUpdated}
            stAmtToggleCancellaionTitle={stAmtToggleCancellaionTitle}
            stAmtToggleCancellaionDescription={
              stAmtToggleCancellaionDescription
            }
            stAmtToggleCancellaionDescriptionMoreThanNinetyDays={
              stAmtToggleCancellaionDescriptionMoreThanNinetyDays
            }
            stAmtToggleCancellaionContinueBtnLabele={
              stAmtToggleCancellaionContinueBtnLabele
            }
            stAmtToggleCancellaionNewDateBtnLabel={
              stAmtToggleCancellaionNewDateBtnLabel
            }
            isOpenViaBottomToggle={isOpenViaBottomToggle}
          />
        )}
      </div>
    </div>
  );
}

export default withBrand(StAmtTogleModal);
